import React from "react";

const UnAuthorized = () => {
  return <div>unauthorized</div>;
};

export default UnAuthorized;
